export const catchFaceOfUBack = (ctx: CanvasRenderingContext2D, catchFaceColor: string, hamidashiColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = catchFaceColor
  // 捕球面折り返し
  ctx.beginPath()
  ctx.moveTo(482, 257) // 左上
  ctx.quadraticCurveTo(465, 279, 470, 315) // 左下
  ctx.quadraticCurveTo(496, 360, 542, 385) // 右下
  ctx.quadraticCurveTo(567, 375, 574, 362) // 右上
  ctx.quadraticCurveTo(532, 303, 482, 257) // 左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // ハミダシ部分
  ctx.fillStyle = hamidashiColor
  ctx.beginPath()
  ctx.moveTo(482, 257) // 左上
  ctx.quadraticCurveTo(465, 279, 470, 315) // 左下
  ctx.quadraticCurveTo(496, 360, 542, 385) // 右下
  ctx.quadraticCurveTo(567, 375, 574, 362) // 右上_外
  ctx.quadraticCurveTo(571, 356, 571, 356) // 右上_内
  ctx.quadraticCurveTo(559, 373, 542, 380) // 右下_内
  ctx.quadraticCurveTo(500, 356, 474, 313) // 左下_内
  ctx.quadraticCurveTo(473, 280, 485, 260) // 左上_内
  ctx.quadraticCurveTo(482, 257, 482, 257) // 左上_内
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}
